import React from "react";
import CountUp from "react-countup";

const Counters = (props) => {
  return (
    <React.Fragment>
      <div className="row align-items-center">
        <div className="col-3" style={{ textAlign: "end" }}>
          <span className="svg-icon svg-icon-3dx svg-icon-success me-2">
            {props.image}
          </span>
        </div>
        <div className="col-9">
          <div
            className="fs-3 fw-bolder"
            data-kt-countup="true"
            data-kt-countup-value="45"
            data-kt-countup-prefix=""
          >
            {props.currency ? "$" : ""}
            <CountUp start={0} end={props.count} reset={true}>
              {/* {({ countUpRef }) => (
                <div className="d-flex">
                  <p className="m-0">{props.currency}</p>
                  <span ref={countUpRef} />
                </div>
              )} */}
            </CountUp>
          </div>
          <div className="fw-bold fs-4 mt-1">{props.CountName}</div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default Counters;
